import { useState, useEffect, useContext } from 'react';

import {
  Grid,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  TableFooter,
  Paper,
  TablePagination,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import { deleteCategory, getCategories } from '../../services/categories.service';
import { BackdropComponent } from '../../components/commons/backdrop/backdrop.component';
import { ProductsContext } from '../../context/products.context';
import { has } from '../../services/summarize.service';

export const CategoriesComponent = () => {

  const { enqueueSnackbar } = useSnackbar();

  const productsContext = useContext(ProductsContext);

  const history = useHistory();

  const [categories, setCategories] = useState([]);
  const [display, setDisplay] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modal, setModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();

  const fetchingCategories = async () => {
    if (productsContext.categories.length === 0) {
      const categoriesItems = await getCategories();
      productsContext.handleCategories(categoriesItems);
      setCategories(categoriesItems);
      setDisplay(categoriesItems);
      setLoading(false);
    } else {
      setCategories(productsContext.categories);
      setDisplay(productsContext.categories);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchingCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEdit = (id) => {
    history.push(`/categories/${id}/edit`);
  }

  const handleDialogDelete = (category) => {
    setSelectedCategory(category);
    setModal(true);
  }

  const handleDelete = async (id) => {
    const deleteItem = await deleteCategory(id);
    const filterCategories = categories.filter(category => category.id !== deleteItem)
    setCategories(filterCategories);
    setDisplay(filterCategories);
    enqueueSnackbar('Categoria eliminada', {
      variant: 'success',
      resumeHideDuration: 3000,
      anchorOrigin:
        { horizontal: 'right', vertical: 'bottom' },
    });
    handleClose();
  }

  const onSearch = (event) => {
    const { value } = event.target;
    setDisplay(categories.filter(category => category.name.toLowerCase().includes(value.toLowerCase())));
  }

  const handleClose = () => {
    setModal(false);
  }

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Grid container spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => history.push('/categories/new')}
              disabled={!has('CATEGORIES::CREATE')}
            >
              Agregar categoria
            </Button>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="search">Buscar</InputLabel>
              <OutlinedInput
                id="search"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                labelWidth={60}
                onChange={onSearch}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <BackdropComponent />
            ) : (
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell align="right">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {display.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                      <TableRow key={row.id}>
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell align="right">
                          <Grid container justifyContent="flex-end" spacing={2}>
                            <Grid item>
                              <IconButton
                                aria-label="edit"
                                color="default"
                                onClick={() => handleEdit(row.id)}
                                disabled={!has('CATEGORIES::EDIT')}
                              >
                                <EditIcon />
                              </IconButton>
                            </Grid>
                            <Grid item>
                              <IconButton
                                aria-label="delete"
                                color="secondary"
                                onClick={() => handleDialogDelete(row)}
                                disabled={!has('CATEGORIES::EDIT')}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TablePagination
                      rowsPerPageOptions={[10, 20, 50]}
                      component="div"
                      count={display.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableFooter>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={modal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          ¿Deseas eliminar la categoria {selectedCategory?.name}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Si eliminas esta categoria no podras restablecerla
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => handleDelete(selectedCategory?.id)} color="secondary" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}